'use client';

import { useEffect } from 'react';
import { supabase } from '@/lib/supabaseClient';
import { useRouter } from 'next/navigation';

export default function SessionReceiver() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleHash = async () => {
        const hash = window.location.hash;
        if (hash && hash.includes('access_token')) {
            console.log('SessionReceiver: Hash detected:', hash);

            // 1. Try manual parsing if auto-detection fails
            const params = new URLSearchParams(hash.replace('#', ''));
            const accessToken = params.get('access_token');
            const refreshToken = params.get('refresh_token');

            if (accessToken && refreshToken) {
                console.log('SessionReceiver: Tokens found, manually setting session...');
                const { data, error } = await supabase.auth.setSession({
                    access_token: accessToken,
                    refresh_token: refreshToken,
                });

                if (error) {
                    console.error('SessionReceiver: Failed to set session manually', error);
                } else if (data.session) {
                    console.log('SessionReceiver: Manual session set success.', data.session);
                    router.refresh(); 
                    router.replace(window.location.pathname); // Clear hash
                }
            } else {
                 // 2. Fallback to getSession which might have picked it up
                 const { data } = await supabase.auth.getSession();
                 if (data.session) {
                     console.log('SessionReceiver: Session found via auto-detection.');
                     router.replace(window.location.pathname);
                 }
            }
        }
    };

    handleHash();
  }, [router]);

  return null; 
}
